import { Language } from '../types/i18n.js'

/**
 * Q12 questions are written by the admin in Estonian (`name`, the primary
 * text) and optionally in English (`name_en`); nothing is machine-translated.
 * The survey shows the respondent's chosen language and falls back to the
 * other one when a translation is missing, so a half-translated form never
 * shows an empty question.
 */
export interface BilingualQuestionText {
    name: string
    name_en?: string | null
}

export interface BilingualQuestionTooltip {
    description?: string | null
    description_en?: string | null
}

const pick = (primary: string | null | undefined, secondary: string | null | undefined) => {
    const p = primary?.trim()
    if (p) return p
    const s = secondary?.trim()
    return s || null
}

export const questionText = (q: BilingualQuestionText, lang: Language): string =>
    (lang === 'en' ? pick(q.name_en, q.name) : pick(q.name, q.name_en)) ?? ''

export const questionTooltip = (q: BilingualQuestionTooltip, lang: Language): string | null =>
    lang === 'en' ? pick(q.description_en, q.description) : pick(q.description, q.description_en)
